"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
exports.useNumberFeatureFlag = exports.useStringFeatureFlag = exports.useBooleanFeatureFlag = exports.createFeatureFlaggingProvider = exports.withFeatureFlaggingSetup = exports.FeatureFlaggingForUser = exports.useLDClient = void 0;
var react_1 = __importStar(require("react"));
var launchdarkly_react_client_sdk_1 = require("launchdarkly-react-client-sdk");
var ub_feature_flagging_core_1 = require("ub-feature-flagging-core");
function useLDClient() {
    return (0, launchdarkly_react_client_sdk_1.useLDClient)();
}
exports.useLDClient = useLDClient;
var FeatureFlaggingForUser = function (_a) {
    var user = _a.user, university = _a.university, children = _a.children;
    var client = (0, launchdarkly_react_client_sdk_1.useLDClient)();
    (0, react_1.useEffect)(function () {
        if (client) {
            var context = {
                kind: 'multi',
                user: user ? __assign({ kind: "user" }, (0, ub_feature_flagging_core_1.createLaunchDarklyUserObject)(user)) : { kind: "user", key: "anonymousUser", anonymous: true },
                university: university && university.slug ? {
                    kind: "university",
                    key: university.slug,
                    slug: university.slug,
                    id: university.id,
                    name: university.name
                } : {
                    kind: "university",
                    key: "anonymousUniversity",
                    anonymous: true
                }
            };
            client.identify(context);
        }
    }, [user, university, client]);
    return react_1["default"].createElement(react_1["default"].Fragment, null, children);
};
exports.FeatureFlaggingForUser = FeatureFlaggingForUser;
var ldConfig = function (clientID) {
    return {
        clientSideID: clientID,
        context: {
            kind: 'multi',
            user: { kind: "user", key: "anonymousUser", anonymous: true },
            university: {
                kind: "university",
                key: "anonymousUniversity",
                anonymous: true
            }
        },
        reactOptions: {
            useCamelCaseFlagKeys: false
        }
    };
};
function withFeatureFlaggingSetup(clientID) {
    return (0, launchdarkly_react_client_sdk_1.withLDProvider)(ldConfig(clientID));
}
exports.withFeatureFlaggingSetup = withFeatureFlaggingSetup;
function createFeatureFlaggingProvider(clientID) {
    return (0, launchdarkly_react_client_sdk_1.withLDProvider)(ldConfig(clientID))(exports.FeatureFlaggingForUser);
}
exports.createFeatureFlaggingProvider = createFeatureFlaggingProvider;
function evaluateType(flagKey, defaultValue) {
    var flagValues = (0, launchdarkly_react_client_sdk_1.useFlags)();
    if (!(flagKey in flagValues)) {
        return defaultValue;
    }
    else if (typeof flagValues[flagKey] != typeof defaultValue) {
        throw TypeError("Flag value was not a ".concat(typeof defaultValue, "!\nFlag value for flag key '").concat(flagKey, "' was a '").concat(typeof flagValues[flagKey], "'"));
    }
    else {
        return flagValues[flagKey];
    }
}
function useBooleanFeatureFlag(flagKey, defaultValue) {
    if (typeof defaultValue != 'boolean') {
        throw TypeError("The provided default value is of the wrong type!\ndefaultValue should be a boolean, it was a ".concat(typeof defaultValue));
    }
    return evaluateType(flagKey, defaultValue);
}
exports.useBooleanFeatureFlag = useBooleanFeatureFlag;
function useStringFeatureFlag(flagKey, defaultValue) {
    if (typeof defaultValue != 'string') {
        throw TypeError("The provided default value is of the wrong type!\ndefaultValue should be a string, it was a ".concat(typeof defaultValue));
    }
    return evaluateType(flagKey, defaultValue);
}
exports.useStringFeatureFlag = useStringFeatureFlag;
function useNumberFeatureFlag(flagKey, defaultValue) {
    if (typeof defaultValue != 'number') {
        throw TypeError("The provided default value is of the wrong type!\ndefaultValue should be a number, it was a ".concat(typeof defaultValue));
    }
    return evaluateType(flagKey, defaultValue);
}
exports.useNumberFeatureFlag = useNumberFeatureFlag;
